import React from 'react';
import styled from 'styled-components';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { RadioCards, RadioCard, H2, P, ButtonPrimary } from '@yuhu-inc/yuhui';

import PropertyIcon from 'assets/property-icon.svg';
import UnitIcon from 'assets/unit-icon.svg';
import TurnoverIcon from 'assets/turnover-icon.svg';
import PropertyIconSelected from 'assets/property-icon-selected.svg';
import UnitIconSelected from 'assets/unit-icon-selected.svg';
import TurnoverIconSelected from 'assets/turnover-icon-selected.svg';
import { media } from 'helpers/MediaHelper';
import { TEMPLATE_PROPERTY_PAGE, TEMPLATE_UNIT_TYPE_PAGE } from './AddTemplateDialog';

const StyledForm = styled(Form)`
  width: 100%;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledH2 = styled(H2)`
  font-size: 24px;
  text-align: center;
  ${media.mobile`
    font-size: 18px;
    text-align: left;
    margin-top: 0px;
    margin-bottom: 4px;
  `};
`;

const StyledP = styled(P)`
  text-align: center;
  ${media.mobile`
    font-size: 12px;
    text-align: left;
    margin-bottom: 0;
  `};
`;

const StyledCardsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 5rem;
  margin-bottom: 5rem;
  ${media.mobile`
    flex-direction: column;
  `};
`;

const StyledCardContainer = styled.div`
  padding: 24px;
  width: 100%;
  max-width: 260px;
  ${media.mobile`
    padding: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
  `};
`;

const StyledCardImg = styled.img`
  width: 110px;
  height: 110px;
  ${media.mobile`
    width: 48px;
    height: 48px;
  `};
`;

const StyledCardTextContainer = styled.div`
  ${media.mobile`
    padding-left: 16px;
  `};
`;

const TemplateTypeCard = ({ value, icon, selectedIcon, headerText, bodyText }) => {
  return (
    <RadioCard value={value}>
      {({ selected }) => (
        <StyledCardContainer>
          <StyledCardImg src={selected ? selectedIcon : icon} alt={value} />
          <StyledCardTextContainer>
            <StyledH2 contentKey={headerText} />
            <StyledP contentKey={bodyText} />
          </StyledCardTextContainer>
        </StyledCardContainer>
      )}
    </RadioCard>
  );
};

const TemplateTypeSchema = Yup.object().shape({
  inspection_type: Yup.string().required(),
});

export const AddTemplateTypePage = ({ setTemplate, goTo }) => {
  return (
    <Formik
      initialValues={{
        inspection_type: undefined,
      }}
      validationSchema={TemplateTypeSchema}
      onSubmit={({ inspection_type }) => {
        setTemplate((template) => {
          return { ...template, inspection_type };
        });
        if (inspection_type === 'property') {
          goTo(TEMPLATE_PROPERTY_PAGE);
        } else if (!!inspection_type) {
          goTo(TEMPLATE_UNIT_TYPE_PAGE);
        }
      }}
    >
      {({ values, setFieldValue }) => (
        <StyledForm name="inspection_template_type">
          <H2 contentKey="landlordPortal.inspections.selectInspectionType" centered />
          <StyledCardsContainer>
            <RadioCards
              name="inspection_type"
              setFieldValue={setFieldValue}
              value={values.inspection_type}
            >
              <TemplateTypeCard
                value="property"
                icon={PropertyIcon}
                selectedIcon={PropertyIconSelected}
                headerText="landlordPortal.inspections.property"
                bodyText="landlordPortal.inspections.propertyText"
              />
              <TemplateTypeCard
                value="unit"
                icon={UnitIcon}
                selectedIcon={UnitIconSelected}
                headerText="landlordPortal.inspections.unit"
                bodyText="landlordPortal.inspections.unitText"
              />
              <TemplateTypeCard
                value="turnover"
                icon={TurnoverIcon}
                selectedIcon={TurnoverIconSelected}
                headerText="landlordPortal.inspections.turnover"
                bodyText="landlordPortal.inspections.turnoverText"
              />
            </RadioCards>
          </StyledCardsContainer>
          <ButtonPrimary
            disabled={!values.inspection_type}
            contentKey="landlordPortal.inspections.next"
          />
        </StyledForm>
      )}
    </Formik>
  );
};
